import GLU from '../glu2.js/src/index';
import SearchLimits from '../enums/SearchLimit';

class OmniSocialExplorerSearchDataSource extends GLU.DataSource {
    static get name() {
        return 'OmniSocialExplorerSearchDataSource';
    }

    static getInstance() {
        return new OmniSocialExplorerSearchDataSource();
    }

    constructor() {
        super();
        this._recentSearchTerms = [];
    }

    get recentSearchTerms() {
        return this._recentSearchTerms;
    }

    addRecentSearchTerm(searchTerm) {
        const recentSearchTermIndex = this._recentSearchTerms.findIndex(term => term === searchTerm);

        if (recentSearchTermIndex === -1) {
            // add new term
            this._recentSearchTerms.unshift(searchTerm);
        } else {
            // push it to the top
            this._recentSearchTerms.splice(recentSearchTermIndex, 1);
            this._recentSearchTerms.unshift(searchTerm);
        }

        if (this._recentSearchTerms.length > SearchLimits.RECENT_SEARCHES_LIMIT) {
            this._recentSearchTerms.pop();
        }

        return this._recentSearchTerms;
    }
}

export default OmniSocialExplorerSearchDataSource;
